import React from 'react';
import { Link } from 'react-router-dom';
import useNavigation from '../../hooks/useNavigation';
import './NavigationSystem.css';

const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];

const NavigationSystem = () => {
  const {
    isOpen,
    currentPage,
    navigationItems,
    toggleNavigation,
    closeNavigation
  } = useNavigation();

  return (
    <>
      <div className="nav-trigger">
        <button 
          className={`nav-trigger__hamburger ${isOpen ? 'nav-trigger__hamburger--open' : ''}`}
          onClick={toggleNavigation}
          aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={isOpen}
        >
          <span className="nav-trigger__line"></span>
          <span className="nav-trigger__line"></span>
          <span className="nav-trigger__line"></span>
        </button>
      </div>

      {isOpen && (
        <div 
          className="nav-backdrop"
          onClick={closeNavigation}
          aria-hidden="true"
        />
      )}

      <nav
        className={`flowing-navigation ${isOpen ? 'flowing-navigation--open' : ''}`}
        aria-label="Main navigation"
      >
        <div className="flowing-navigation__content">
          <ul className="flowing-navigation__menu">
            {navigationItems.map((item, index) => (
              <li key={item.path} className="flowing-navigation__item">
                <Link
                  to={item.path}
                  className={`flowing-navigation__link ${
                    item.name === currentPage ? 'flowing-navigation__link--active' : ''
                  }`}
                  onClick={closeNavigation}
                >
                  <span className="flowing-navigation__numeral">{ROMAN[index]}</span>
                  <span className="flowing-navigation__label">{item.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </>
  );
};

export default NavigationSystem;